import { workerFetch } from "./worker-base";

export interface XtreamCategory {
  category_id: string;
  category_name: string;
}

export interface XtreamLiveChannel {
  stream_id: number;
  name: string;
  stream_type: string;
  stream_icon: string | null;
  category_id: string | null;
}

export function buildXtreamLiveUrl(base: string, user: string, pass: string, streamId: number): string {
  const trimmed = base.replace(/\/+$/, "");
  return `${trimmed}/live/${user}/${pass}/${streamId}.ts`;
}

export const XtreamAdapter = {
  async listLiveCategories(base: string, user: string, pass: string): Promise<XtreamCategory[]> {
    const target = `${base.replace(/\/+$/, "")}/player_api.php?username=${encodeURIComponent(user)}&password=${encodeURIComponent(pass)}&action=get_live_categories`;
    const url = `/proxy?url=${encodeURIComponent(target)}`;
    const res = await workerFetch(url);
    if (!res.ok) throw new Error(`Xtream: HTTP ${res.status}`);
    return res.json();
  },

  async listLiveChannels(base: string, user: string, pass: string, categoryId?: string): Promise<XtreamLiveChannel[]> {
    const params = new URLSearchParams({
      username: user,
      password: pass,
      action: "get_live_streams",
    });
    if (categoryId) params.set("category_id", categoryId);
    const target = `${base.replace(/\/+$/, "")}/player_api.php?${params.toString()}`;
    const url = `/proxy?url=${encodeURIComponent(target)}`;
    const res = await workerFetch(url);
    if (!res.ok) throw new Error(`Xtream: HTTP ${res.status}`);
    return res.json();
  },

  getStreamUrl(base: string, user: string, pass: string, streamId: number): string {
    // Direct browser→panel, NOT through Worker.
    return buildXtreamLiveUrl(base, user, pass, streamId);
  },
};
